<template>
  <div>
    <div v-if="isMobile">
      <div class="flex-row title-item-m">
        <!--logo-->
        <div>
          <img src="@/apps/assets/logo.svg" style="height: 34px"/>
        </div>
      </div>
      <!--      -->
      <div style="padding: 20px">
        <div class="flex-center">
          <!--img-->
          <div style="margin-right: 20px">
            <img :src="$apps.fileUrl(website.websiteIcon)" style="height: 70px;width: 70px;"/>
          </div>
          <!--website-->
          <div>
            <div class="website-name-m">{{ website.websiteName }}</div>
            <div style="color: #6a6a67;margin-bottom: 5px;">Reviews {{ website.reviewsNum }} Excellent
            </div>
            <div>
              <img v-if="website.starNum==3" src="@/apps/assets/stars-3.svg" style="height: 30px"/>
              <img v-if="website.starNum==4" src="@/apps/assets/stars-4.svg" style="height: 30px"/>
              <img v-if="website.starNum>=5" src="@/apps/assets/stars-5.svg" style="height: 30px"/>
            </div>
          </div>
        </div>

        <div @click="websiteTo( website.website)" style="margin-top: 20px">
          <div style="border: 1px solid #205cdc;padding: 15px 100px 15px 30px;border-radius: 5px">
            <div class="flex-center">
              <img src="@/apps/assets/share.svg" style="height: 16px"/>
              <span style="margin-left: 10px;font-weight: bold;color: #205cdc;">{{ website.website }}</span>
            </div>
            <div style="margin-top: 10px">Visit this website</div>
          </div>
        </div>
      </div>
      <!--      -->
      <div class="score-div-m">
        <div>
          <div class="website-icon-desc">
            <div style="font-size: 16px;font-weight: bold">{{ website.websiteA }}</div>
            <div style="font-size: 12px;color: #6a6a67">{{ website.websiteB }}</div>
            <img :src="$apps.fileUrl(website.websiteIcon)" style="height: 70px;width: 70px"/>
            <div style="font-size: 14px;font-weight: bold">{{ website.websiteC }}</div>
            <div style="font-size: 14px;">{{ website.websiteD }}</div>
          </div>

          <div></div>

          <div class="website-icon-desc" style="margin-top: 20px">
            <div style="font-size: 16px;font-weight: bold">{{ website.websiteE }}</div>
            <div style="font-size: 12px;color: #6a6a67">{{ website.websiteF }}</div>
            <div style="margin-top: 20px;font-size: 14px;">{{ website.websiteJ }}</div>
          </div>

          <div></div>

          <div class="website-icon-desc" style="margin-top: 20px">
            <div style="font-size: 16px;font-weight: bold">Contact</div>
            <div style="font-size: 14px;">{{ website.email }}</div>
            <div style="font-size: 14px;">{{ website.phone }}</div>
            <div style="font-size: 14px;">{{ website.address }}</div>
            <div style="font-size: 14px;">{{ website.mailCode }}</div>
            <div style="font-size: 14px;">{{ website.state }}</div>
            <div style="font-size: 14px;">{{ website.country }}</div>
          </div>
          <div></div>
        </div>
        <!---->
        <div>
          <div class="score-item" style="background-color: #ffffff; border: 1px solid #e5e5dd;border-radius: 10px">
            <div class="flex-center">
              <div class="website-reviews">Reviews</div>
              <img src="@/apps/assets/star.svg" style="height: 24px;margin-left: 5px;margin-right: 5px"/>
              <div class="website-reviews">{{ website.scoreNum }}</div>
            </div>
            <div style="margin-top: 5px;margin-bottom: 10px">{{ website.reviewsNum }} total</div>
            <!--            -->
            <div class="flex-center">
              <div style="width: 60px">5-star</div>
              <v-progress-linear rounded v-model="knowledge5" height="14">
                <strong style="font-size: 12px;color: #e5e5dd">96%</strong>
              </v-progress-linear>
            </div>

            <div class="flex-center">
              <div style="width: 60px">4-star</div>
              <v-progress-linear rounded v-model="knowledge4" height="14">
                <strong style="font-size: 12px">1%</strong>
              </v-progress-linear>
            </div>

            <div class="flex-center">
              <div style="width: 60px">3-star</div>
              <v-progress-linear rounded v-model="knowledge3" height="14">
                <strong style="font-size: 12px">1%</strong>
              </v-progress-linear>
            </div>

            <div class="flex-center">
              <div style="width: 60px">2-star</div>
              <v-progress-linear rounded v-model="knowledge2" height="14">
                <strong style="font-size: 12px">1%</strong>
              </v-progress-linear>
            </div>

            <div class="flex-center">
              <div style="width: 60px">1-star</div>
              <v-progress-linear rounded v-model="knowledge1" height="14">
                <strong style="font-size: 12px">1%</strong>
              </v-progress-linear>
            </div>

          </div>
          <!--score list-->
          <div>
            <div class="score-list" v-for="(item,k) in websiteList" :key="k">
              <div class="person-item">
                <div>
                  <v-avatar color="red">
                    <span class="text-h5">{{ item.username.slice(0, 2).toUpperCase() }}</span>
                  </v-avatar>
                </div>
                <div style="margin-left: 10px">
                  <div style="font-size: 16px;font-weight: bold">{{ item.username }}</div>
                  <div><span style="font-size: 12px;color: #6a6a67">{{ item.usefulNum }} review</span><span
                      style="margin-left: 10px;font-size: 14px;color: #6a6a67">{{ item.address }}</span></div>
                </div>
              </div>
              <!--            -->
              <div style="padding: 10px 20px">
                <div class="flex-center just-between">
                  <div class="flex-center">
                    <div>
                      <!--                      <img src="@/apps/assets/stars-5.svg"  style="height: 16px"/>-->
                      <img v-if="item.scoreNum==3" src="@/apps/assets/stars-3.svg" style="height: 16px"/>
                      <img v-if="item.scoreNum==4" src="@/apps/assets/stars-4.svg" style="height: 16px"/>
                      <img v-if="item.scoreNum>=5" src="@/apps/assets/stars-5.svg" style="height: 16px"/>
                    </div>
                    <!--                    <div style="margin-left: 20px;color: #6a6a67">Invited</div>-->
                  </div>
                  <!--                  <div style="color: #6a6a67;font-size: 14px">{{ item.saveTime }}</div>-->
                </div>
              </div>
              <!--            -->
              <div style="padding: 0px 20px;font-weight: bold">{{ item.titleContent }}</div>
              <!--            -->
              <div style="padding: 0px 20px;margin-top: 10px">{{ item.content }}
              </div>
              <!--            -->
              <div style="padding: 10px 20px"><span style="font-weight: bold">Date of experience:</span>
                {{ dateFormat(item.saveTime) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    -->
    <div v-else>
      <div class="flex-row title-item">
        <!--logo-->
        <div>
          <img src="@/apps/assets/logo.svg" style="height: 34px"/>
        </div>
      </div>
      <!--    -->
      <div class="website-div flex-row just-between">
        <div class="flex-row">
          <!--img-->
          <div style="width: 198px">
            <img :src="$apps.fileUrl(website.websiteIcon)" style="height: 149px;width: 149px;"/>
          </div>
          <!--website-->
          <div>
            <div class="website-name">{{ website.websiteName }}</div>
            <div style="margin-top: 10px;color: #6a6a67;margin-bottom: 5px;">Reviews {{ website.reviewsNum }} Excellent
            </div>
            <div>
              <img v-if="website.starNum==3" src="@/apps/assets/stars-3.svg" style="height: 40px"/>
              <img v-if="website.starNum==4" src="@/apps/assets/stars-4.svg" style="height: 40px"/>
              <img v-if="website.starNum>=5" src="@/apps/assets/stars-5.svg" style="height: 40px"/>
            </div>
            <!--          <div style="display: flex">-->
            <!--            <div class="website-desc">-->
            <!--              &lt;!&ndash;              <img src="@/apps/assets/verified.svg"  style="height: 16px"/>&ndash;&gt;-->
            <!--              <span>VERIFIED COMPANY</span>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
        <!--url -->
        <div @click="websiteTo( website.website)">
          <div style="border: 1px solid #205cdc;padding: 15px 100px 15px 30px;border-radius: 5px">
            <div class="flex-center">
              <img src="@/apps/assets/share.svg" style="height: 16px"/>
              <span style="margin-left: 10px;font-weight: bold;color: #205cdc;">{{ website.website }}</span>
            </div>
            <div style="margin-top: 10px">Visit this website</div>
          </div>
        </div>
      </div>
      <!--score-->
      <div class="score-div">
        <!--score list-->
        <div class="flex-row just-between">
          <!--        -->
          <div style="flex: 4.5">
            <div class="score-item" style="background-color: #ffffff; border: 1px solid #e5e5dd;border-radius: 10px">
              <div class="flex-center">
                <div class="website-reviews">Reviews</div>
                <img src="@/apps/assets/star.svg" style="height: 24px;margin-left: 5px;margin-right: 5px"/>
                <div class="website-reviews">{{ website.scoreNum }}</div>
              </div>
              <div style="margin-top: 5px;margin-bottom: 10px">{{ website.reviewsNum }} total</div>
              <!--            -->
              <div class="flex-center">
                <div style="width: 60px">5-star</div>
                <v-progress-linear rounded v-model="knowledge5" height="14">
                  <strong style="font-size: 12px;color: #e5e5dd">96%</strong>
                </v-progress-linear>
              </div>

              <div class="flex-center">
                <div style="width: 60px">4-star</div>
                <v-progress-linear rounded v-model="knowledge4" height="14">
                  <strong style="font-size: 12px">1%</strong>
                </v-progress-linear>
              </div>

              <div class="flex-center">
                <div style="width: 60px">3-star</div>
                <v-progress-linear rounded v-model="knowledge3" height="14">
                  <strong style="font-size: 12px">1%</strong>
                </v-progress-linear>
              </div>

              <div class="flex-center">
                <div style="width: 60px">2-star</div>
                <v-progress-linear rounded v-model="knowledge2" height="14">
                  <strong style="font-size: 12px">1%</strong>
                </v-progress-linear>
              </div>

              <div class="flex-center">
                <div style="width: 60px">1-star</div>
                <v-progress-linear rounded v-model="knowledge1" height="14">
                  <strong style="font-size: 12px">1%</strong>
                </v-progress-linear>
              </div>

            </div>
            <!--score list-->
            <div>
              <div class="score-list" v-for="(item,k) in websiteList" :key="k">
                <div class="person-item">
                  <div>
                    <v-avatar color="red">
                      <span class="text-h5">{{ item.username.slice(0, 2).toUpperCase() }}</span>
                    </v-avatar>
                  </div>
                  <div style="margin-left: 10px">
                    <div style="font-size: 16px;font-weight: bold">{{ item.username }}</div>
                    <div><span style="font-size: 12px;color: #6a6a67">{{ item.usefulNum }} review</span><span
                        style="margin-left: 10px;font-size: 14px;color: #6a6a67">{{ item.address }}</span></div>
                  </div>
                </div>
                <!--            -->
                <div style="padding: 10px 20px">
                  <div class="flex-center just-between">
                    <div class="flex-center">
                      <div>
                        <!--                      <img src="@/apps/assets/stars-5.svg"  style="height: 16px"/>-->
                        <img v-if="item.scoreNum==3" src="@/apps/assets/stars-3.svg" style="height: 16px"/>
                        <img v-if="item.scoreNum==4" src="@/apps/assets/stars-4.svg" style="height: 16px"/>
                        <img v-if="item.scoreNum>=5" src="@/apps/assets/stars-5.svg" style="height: 16px"/>
                      </div>
                      <!--                    <div style="margin-left: 20px;color: #6a6a67">Invited</div>-->
                    </div>
                    <!--                  <div style="color: #6a6a67;font-size: 14px">{{ item.saveTime }}</div>-->
                  </div>
                </div>
                <!--            -->
                <div style="padding: 0px 20px;font-weight: bold">{{ item.titleContent }}</div>
                <!--            -->
                <div style="padding: 0px 20px;margin-top: 10px">{{ item.content }}
                </div>
                <!--            -->
                <div style="padding: 10px 20px"><span style="font-weight: bold">Date of experience:</span>
                  {{ dateFormat(item.saveTime) }}
                </div>
              </div>
            </div>
          </div>
          <div style="width: 30px"></div>
          <!--        -->
          <div style="flex: 2">
            <div class="website-icon-desc">
              <div style="font-size: 16px;font-weight: bold">{{ website.websiteA }}</div>
              <div style="font-size: 12px;color: #6a6a67">{{ website.websiteB }}</div>
              <img :src="$apps.fileUrl(website.websiteIcon)" style="height: 149px;width: 149px"/>
              <div style="font-size: 14px;font-weight: bold">{{ website.websiteC }}</div>
              <div style="font-size: 14px;">{{ website.websiteD }}</div>
            </div>

            <div></div>

            <div class="website-icon-desc" style="margin-top: 20px">
              <div style="font-size: 16px;font-weight: bold">{{ website.websiteE }}</div>
              <div style="font-size: 12px;color: #6a6a67">{{ website.websiteF }}</div>
              <div style="margin-top: 20px;font-size: 14px;">{{ website.websiteJ }}</div>
            </div>

            <div></div>

            <div class="website-icon-desc" style="margin-top: 20px">
              <div style="font-size: 16px;font-weight: bold">Contact</div>
              <div style="font-size: 14px;">{{ website.email }}</div>
              <div style="font-size: 14px;">{{ website.phone }}</div>
              <div style="font-size: 14px;">{{ website.address }}</div>
              <div style="font-size: 14px;">{{ website.mailCode }}</div>
              <div style="font-size: 14px;">{{ website.state }}</div>
              <div style="font-size: 14px;">{{ website.country }}</div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <!--      -->
      <v-pagination :length="totalPages"></v-pagination>
    </div>
  </div>
</template>

<script>
import {useRoute} from 'vue-router';
import {onMounted, reactive, ref} from 'vue';
import axios from "@/frameworks/utils/axios"

export default {
  name: 'WebsiteScore',

  setup() {
    const code = ref("1209a681-47ca-4aa2-91c9-745360d34cb4");

    const route = useRoute();

    const isMobile = ref(false);

    if (route.query.code) {
      code.value = route.query.code;
    }

    const knowledge5 = ref(96);
    const knowledge4 = ref(1);
    const knowledge3 = ref(1);
    const knowledge2 = ref(1);
    const knowledge1 = ref(1);

    const url = ref("sys/website/code");
    const scoreUrl = ref("/base/websiteScore/listPage");

    const totalPages = ref(1);
    let website = reactive({});
    let websiteList = reactive([]);

    const params = reactive({
      code: code
    })

    const paramsScore = reactive({
      websiteId: code,
      total: 0,
      pageNum: 1,
      pageSize: 30,
    })

    onMounted(() => {
      initialize();
      initializeScore();
      checkMobile();
      window.addEventListener('resize', checkMobile);
    });

    const initialize = async () => {
      const response = await axios.postjson(url.value, params);
      let res = response.data;
      if (res.code != 0) {
        return;
      }
      Object.assign(website, res.data);
    };

    const initializeScore = async () => {
      const response = await axios.postjson(scoreUrl.value, paramsScore);
      let res = response.data;
      if (res.code != 0) {
        return;
      }
      Object.assign(websiteList, res.data.content);
      totalPages.value = res.data.totalPages
    };

    const checkMobile = () => {
      isMobile.value = window.innerWidth < 768;
    }

    const dateFormat = (dateStr) => {
      const date = new Date(dateStr);

      const options = {year: 'numeric', month: 'long', day: 'numeric'};

      const formattedDate = date.toLocaleDateString('en-US', options);

      return formattedDate
    }

    const websiteTo = (website) => {
      let realWebsite = "";
      if (website.contain("https://")) {
        realWebsite = website
      } else {
        realWebsite = "https://" + website
      }
      window.location.href = realWebsite
    }

    return {
      code,
      knowledge5,
      knowledge4,
      knowledge3,
      knowledge2,
      knowledge1,
      website,
      websiteList,
      dateFormat,
      websiteTo,
      isMobile,
      totalPages
    }
  },
}
</script>

<style scoped>
.title-item {
  background-color: #1c1c1c;
  padding: 0px 180px;
  height: 72px;
  align-items: center;
}

.title-item-m {
  background-color: #1c1c1c;
  padding: 0px 30px;
  height: 72px;
  align-items: center;
}

.website-div {
  padding: 32px 100px;
}


.score-div {
  background-color: #fcfbf3;
  padding: 16px 100px;
}

.score-div-m {
  background-color: #fcfbf3;
  padding: 16px;
}

.score-item {
  padding: 24px;
}

.website-name {
  font-size: 32px;
  color: #1c1c1c;
  font-weight: bold;
}

.website-name-m {
  font-size: 24px;
  color: #1c1c1c;
  font-weight: bold;
}

.website-desc {
  font-size: 10px;
  color: #1c1c1c;
  font-weight: bold;
  background-color: #b1f2d0;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  margin-top: 10px;
}

.website-reviews {
  font-size: 24px;
  color: #1c1c1c;
  font-weight: bold;
}

.person-item {
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e5e5dd;
}

.score-list {
  margin-top: 16px;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #e5e5dd;
}

.website-icon-desc {
  padding: 20px;
  border: 1px solid #e5e5dd;
  background-color: #ffffff;
  border-radius: 10px;
}
</style>
